// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.checkbox[data-v-6dc0151d] .v-input--selection-controls__input {\r\n  margin: 0.3rem !important;\n}\n.checkbox[data-v-6dc0151d] .v-input--selection-controls__ripple {\r\n  height: 0 !important;\n}\r\n/*.row {\r\n  border: solid 1px orange;\r\n}\r\n.col {\r\n  border: solid 1px green;\r\n}*/\r\n", ""]);
// Exports
module.exports = exports;
